/* @flow */

import * as React from 'react';
import {useDispatch} from 'react-redux';

import {HelpButton} from 'shells/help';

import {openAttributionModal} from '../../setup/sources/onboarding/attribution-modal-actions';

export function AttributionReportDescription() {
    const dispatch = useDispatch();

    return (
        <div className='flex'>
            Where do our best leads come from?
            <HelpButton onClick={() => dispatch(openAttributionModal())} />
        </div>
    );
}
